export const DefaultAllowedRoles = {
    isOrdering: false,
    isAccounting: false,
    isInventory: false,
    isSupervisor: false,
    isCEO: false,
    isCustomer: false,
  }
  
  export const Roles = {
    Salesman: "sm",
    InventoryOfficer: "io",
    Accountant: "ac",
    Supervisor: "sp",
    CEO: "ceo",
    Customer:"cs",
  };
  export const getCurrentUserRole =(userRole)=> {
    if (userRole === Roles.Customer) {
      return {...DefaultAllowedRoles,isCustomer: true}
    }
    else if (userRole === Roles.Salesman) {
      return {...DefaultAllowedRoles,isOrdering: true}
    }
    else if (userRole === Roles.InventoryOfficer) {
      return {...DefaultAllowedRoles,isOrdering: true,isInventory: true}
    }
    else if (userRole === Roles.Accountant) {
      return {...DefaultAllowedRoles,isOrdering: true,isInventory: true,isAccounting: true}
    }
    else if (userRole === Roles.Supervisor) {
      return {...DefaultAllowedRoles,isOrdering: false,isInventory: true,isAccounting: true,isSupervisor: true}
    }
    else if (userRole === Roles.CEO) {
      return {...DefaultAllowedRoles,isOrdering: false,isInventory: true,isAccounting: true,isSupervisor: true,isCEO: true}
    }

  };

  export const getNavigationStackForNavBar = (role) => {
    let items = ["Home"];
    

    if (role.isCustomer) {
      items.push("Dashboard");
      items.push("Create Order");
      items.push("OrderStatus");
      items.push("Contact Us");
    }
    if (role.isAccounting || role.isSupervisor) {
      items.push("Dashboard");
      items.push("Create Order");
      items.push("OrderStatus");
      items.push("Reports");
      items.push("Setting");
      items.push("Issues");
      items.push("Customers");
      items.push("Products");
      items.push("Raw-Material");
      items.push("Suppliers");
      items.push("payment");
      // items.push("Departments");
    }
    if (role.isOrdering) {
      items.push("Create Order");
      items.push("OrderStatus");
      items.push("Reports");

    }
  
    return items;
  };